<!--US Page-->
<div class="dtfinsurance" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Insurance_Carousel.png);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'Insurance.TruckTitle' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text">
        {{ 'Insurance.TruckHeader' | translate }}
      </p>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'Insurance.InsuranceHeader' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'Insurance.InsuranceCopy1' | translate }}</p>
      </div>
    </div>
  </section>

  <!--Benefits you can count on 1-->
  <div class="mercedes-me-login__column">
    <h2 class="mercedes-me-login__column-headline">{{ 'Insurance.BenefitsHeader' | translate }}</h2>
    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Finance-into-a-contract_Icon.png">
        <h4 class="header1"> {{ 'Insurance.BenefitsTitle1' | translate }}</h4>
        <p class="paragraph1"> {{ 'Insurance.BenefitsCopy1' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Lock-in-your-rate_Icon.png">
        <h4 class="header1"> {{ 'Insurance.BenefitsTitle2' | translate }}</h4>
        <p class="paragraph1"> {{ 'Insurance.BenefitsCopy2' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Immediate-Coverage_Icon.png">
        <h4 class="header1">{{ 'Insurance.BenefitsTitle3' | translate }}</h4>
        <p class="paragraph1">{{ 'Insurance.BenefitsCopy3' | translate }}</p>
      </li>
    </ul>
  </div>

  <!-- Protect Your investment-->
  <div class="dtfbrochures__page2">
    <div class="dtfbrochures__container2">
      <h4 class="dtfbrochures__header21">{{ 'Insurance.FinancingHeader' | translate }}</h4>
    <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/Physical-Damage_Image_494x264px.jpg">
            <h4> {{ 'Insurance.FinancingTitle1' | translate }}</h4>
            <p *ngIf="!enableBrochure" class="paragraph2"> {{ 'Insurance.FinancingCopy1' | translate }}</p>
            <p *ngIf="enableBrochure" class="paragraph2"> {{ 'Insurance.FinancingCopy1New' | translate }}</p>
          </div>
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/Non-trucking-Liability_Image_494x264.jpg">
            <h4> {{ 'Insurance.FinancingTitle2' | translate }}</h4>
            <p *ngIf="!enableBrochure" class="paragraph2"> {{ 'Insurance.FinancingCopy2' | translate }}</p>
            <p *ngIf="enableBrochure" class="paragraph2"> {{ 'Insurance.FinancingCopy2New' | translate }}</p>

         </div>
      </div>
      </div>
      <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/GAP-GAPlus-Protection-Program_Image_494x264px.jpg">
            <h4 *ngIf="!enableBrochure"> {{ 'Insurance.FinancingTitle3' | translate }}</h4>
            <h4 *ngIf="enableBrochure"> {{ 'Insurance.FinancingTitle3New' | translate }}</h4>
            <p  *ngIf="!enableBrochure" class="paragraph2"> {{ 'Insurance.FinancingCopy3' | translate }}</p>
            <p  *ngIf="enableBrochure" class="paragraph2"> {{ 'Insurance.FinancingCopy3New' | translate }}</p>
         </div>
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/InsuranceTest.png">
            <h4> <a style="text-decoration: underline; color: white;" href="{{this.targetRedirect}}connected-insurance">{{ 'Insurance.FinancingTitle4' | translate }}</a></h4>
            <p class="paragraph2"> {{ 'Insurance.FinancingCopy4' | translate }}</p>
         </div>
      </div>
      </div>
  </div>


  <section class='mbfs-red-banner-inner'>
    <div class="mbfs-red-banner-inner__box">
      <div class="mbfs-red-banner-inner__box--text">
        <h2 class="mbfs-red-banner-inner__header-title">
          {{'Calculator.Information' | translate }} 
          <a href="{{this.targetRedirect}}brochures">{{'Calculator.ClickHere' | translate }} </a>
          {{'FinanceLeaseSolutions.MoreInfo2' | translate }} <a href="{{this.targetRedirect}}dealerlocator"> {{
            'Header.FindADealer' | translate }}</a>
        </h2>
      </div>
    </div>
  </section>

  <!--Copyright footer-->
  <footer id="mbfs-footer">
    <div role="contentinfo">
      <div class="mbfs-copyright">
        <p *ngIf="!enableBrochure" class="paragraph1"> {{ 'Insurance.Disclaimer' | translate }} </p>
        <p *ngIf="enableBrochure" class="paragraph1"> {{ 'Insurance.DisclaimerNew' | translate }} </p>
        <p class="paragraph1"> {{ 'Insurance.Disclaimer2' | translate }} </p>
      </div>
    </div>
  </footer>
</div>
</div>

<!--Canada Page-->
<div class="dtfinsurance" *ngIf="isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Insurance_top_37Tint_Image_1140x670.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'Insurance.TruckTitle' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text-demi">
        {{ 'Insurance.TruckHeader' | translate }}
      </p>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'Insurance.InsuranceHeader' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'Insurance.InsuranceCopy1' | translate }}</p>
      </div>
    </div>
  </section>

  <!--Benefits you can count on 1-->
  <div class="mercedes-me-login__column">
    <h2 class="mercedes-me-login__column-headline">{{ 'Insurance.BenefitsHeader' | translate }}</h2>
    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Finance-into-a-contract_Icon.png">
        <p class="paragraph1"> {{ 'Insurance.BenefitsCopy1' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Lock-in-your-rate_Icon.png">
        <p class="paragraph1"> {{ 'Insurance.BenefitsCopy2' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Immediate-Coverage_Icon.png">
        <p class="paragraph1">{{ 'Insurance.BenefitsCopy3' | translate }}</p>
      </li>
    </ul>
  </div>

  <!-- Protect Your investment-->
  <div class="dtfbrochures__page2">
    <div class="dtfbrochures__container2">
      <h4 class="dtfbrochures__header21">{{ 'Insurance.FinancingHeader' | translate }}</h4>
      <div class="row5">
        <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingHeaderText' | translate }}</p>
        <div class="col-sm-6">
          <img src="static/assets/img/dtf-assets/images/redesign/GAP-GAPlus-Protection-Program_Image_494x264px.jpg"><br><br>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle3' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy3' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle5' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy5' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle7' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy7' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle9' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy9' | translate }}</p>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy9_1' | translate }}</p>
        </div>
        <div class="col-sm-6">
          <img src="static/assets/img/dtf-assets/images/redesign/Pay-as-you-drive_Image_494x264px.jpg"><br><br>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle4' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy4' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle6' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy6' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle8' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy8' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle10' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy10' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle11' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy11' | translate }}</p>
          <h4 class="dtfbrochures__title1">{{ 'Insurance.FinancingTitle12' | translate }}</h4>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.FinancingCopy12' | translate }}</p>
          <p class="dtfbrochures__paragraph2">{{ 'Insurance.Disclaimer' | translate }}</p>
        </div>
     </div>

    </div>
  </div>



  <section class='mbfs-red-banner-inner'>
    <div class="mbfs-red-banner-inner__box">
      <div class="mbfs-red-banner-inner__box--text">
        <h2 class="mbfs-red-banner-inner__header-title">
          {{'Calculator.Information' | translate }} 
          <a href="{{this.targetRedirect}}brochures">{{'Calculator.ClickHere' | translate }} </a>
          {{'FinanceLeaseSolutions.MoreInfo2' | translate }} <a href="{{this.targetRedirect}}dealerlocator"> {{
            'Header.FindADealer' | translate }}</a>
        </h2>
      </div>
    </div>
  </section>

<!-- Marsh Insurance solution-->
<div class="dtfbrochures__page2">
  <div style="background-image: url('/static/assets/img/dtf-assets/images/redesign/blue_image.png');">
    <h4 class="dtfbrochures__header2">{{ 'MarshInsurance.header' | translate }}</h4>
 
   <div style="text-align: center !important;">
    <p class="dtfbrochures__paragraph2" style="padding-left: 20%;padding-right: 20%;">{{ 'MarshInsurance.headerText' | translate }}</p>
    <br>
    <img src="/static/assets/img/dtf-assets/images/redesign/marsh.png" alt="image" class="center">
    <br>
    <br>
    <a  class="mbfs-button" href="{{'MarshInsurance.buttonUrl'  | translate}}">{{ 'Dashboard.InsuranceButton'  | translate }}</a>
    <!-- <button type="submit" class="mbfs-button"><a href="https://www.google.com/" target='_blank'>{{ 'Dashboard.InsuranceButton' | translate }}</a></button> -->
    <br>
      <br>
  </div>

  </div>
</div>
  <!--Copyright footer-->
  <!-- <footer id="mbfs-footer">
    <div role="contentinfo">
      <div class="mbfs-copyright">
        <p class="paragraph1"> {{ 'Insurance.Disclaimer' | translate }} </p>
      </div>
    </div>
  </footer> -->
</div>
